import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminRequestDto, AdminResponseDto, AdminService, OrderService, StoreOutputDto, StorePayingInputDto, StorePayingService, StoreService } from 'src/generated_client';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-liquidaciones-empresas',
  templateUrl: './liquidaciones-empresas.component.html',
  styleUrls: ['./liquidaciones-empresas.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LiquidacionesEmpresasComponent implements OnInit {

  displayedColumns: string[] = ['order', 'date', 'client', 'shopSale', 'commission', 'liquidacion'];
  dataSource: any = [];
  secondTableColumns: string[] = ['status', 'quantity'];
  secondTableData = noLiquidablesData;
  allStores: StoreOutputDto[] = [];
  dateFrom: any;
  dateTo: any;
  totalNeto: number = 0;
  totalCommission: number = 0;
  totalLiq: number = 0;
  totalOrders: number = 0;
  ordersList: number[] = [];
  observaciones: string = '';
  storePayingInput: StorePayingInputDto = {} as StorePayingInputDto;
  password: string = '';
  currentUser: AdminResponseDto = {};

  empresasForm: FormGroup = this.fb.group({
    company: ['', Validators.required],
    dateFrom: [''],
    dateTo: [''],
    number: [''],
  })

  constructor(
    public orderService: OrderService,
    public storeService: StoreService,
    public storePayingService: StorePayingService,
    public snackBar: SnackBarService,
    public adminService: AdminService,
    public authService: AuthService,
    private fb: FormBuilder
  ) { }

  private toArray<T>(response: any): T[] {
    if (Array.isArray(response)) {
      return response;
    }

    const candidates = [response?.data, response?.items, response?.result, response?.values];
    const firstArray = candidates.find(Array.isArray);

    return firstArray ?? [];
  }

  ngOnInit() {
    this.storeService.apiStoreGetAllStoresGet().subscribe(response => {
      this.allStores = this.toArray<StoreOutputDto>(response);
    })
  }

  inpuDateFrom(event: any) {
    this.dateFrom = event.value;
  }

  inpuDateTo(event: any) {
    this.dateTo = event.value;
  }

  search(form: any) {
    this.ordersList = [];
    this.totalNeto = 0;
    this.totalCommission = 0;
    this.totalLiq = 0;
    this.totalOrders = 0;

    const dateTo = this.dateTo ? moment(this.dateTo).endOf('day').toDate() : undefined;
    this.orderService.apiOrderGetOrdersByStoreAndDateGet(form.company, this.dateFrom, dateTo).subscribe(response => {
      const orders = this.toArray<any>(response);
      this.dataSource = orders;
      this.totalOrders = orders.length;
      orders.forEach(r => {
        this.totalNeto = this.totalNeto + r.qtTotal!;
        this.totalCommission = this.totalCommission + r.qtComision!;
        this.totalLiq = this.totalLiq + (r.qtTotal! - r.qtComision!);
        this.ordersList.push(r.cdOrder!)
      })
    })
  }

  confirm() {
    this.currentUser = this.authService.currentUser();
    let confirm: AdminRequestDto = {
      dsPassword: this.password,
      dsUsername: this.currentUser.dsUsername!
    }
    this.adminService.apiAdminConfirmPost(confirm).subscribe(response => {
      this.storePayingInput = {
        cdOrders: this.ordersList,
        cdStore: this.empresasForm.get('company')!.value,
        dsObservacion: this.observaciones,
        qtComision: this.totalCommission,
        qtNeto: this.totalNeto,
        qtPaying: this.totalLiq,
        qtTotal: this.totalNeto + this.totalCommission,
      }
      this.storePayingService.apiStorePayingPostPost(this.storePayingInput).subscribe(response => {
        console.log(response)
      }, error => {
        console.log(error)
      })
    }, error => {
      this.snackBar.openSnackBar('La contraseña es incorrecta.', 'Aceptar');
    })

  }

}

export interface NoLiquidables {
  status: string,
  quantity: string,
}

const noLiquidablesData: NoLiquidables[] = [
  {
    status: 'Activo', quantity: '5'
  }
]
